module.exports = "<p>\n  lwf-series works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/Component/lwf-series/lwf-series.component.html
// module id = ../../../../../src/app/Component/lwf-series/lwf-series.component.html
// module chunks = main